import React from 'react'
import { SelectDropdown } from './'
import { Col } from 'reactstrap'
import values from 'mout/object/values'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';

export default function DistrictDropdown({
  selectedDistrict,
  selectOption,
  disabled,
  districts,
}) {
  const sortedDists = sortByPropText(values(districts || []), 'name')
  return (
    <Col className='manage-users-select select-district'>
      <SelectDropdown
        name='district'
        value={(selectedDistrict || '') && selectedDistrict.id}
        selectOption={selectOption}
        disabled={disabled}
      >
        <option value=''></option>
        {sortedDists.map((dist) => 
          <option 
            key={`selOp${dist.id}`} 
            value={dist.id} 
          >
            {dist.name}
          </option>
        )}
      </SelectDropdown>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/DistrictDropdown.js